module.exports = __webpack_public_path__ + "img/add.619d7a9f.png";